export enum PropertyProtectionBenefitType {
  BUILDING = "Building",
  CONTENTS = "Contents",
  LIABILITY = "Liability",
  ALTERNATIVE_ACCOMMODATION = "AlternativeAccommodation",
  LOSS_OF_RENT = "LossOfRent",
  LEGAL_EXPENSES = "LegalExpenses",
}
